import * as formTemplateApi from '../../../../../api/administration/formTemplateApi';
import * as actionTypes from './actionTypes';

export function fetchFormTemplatesSuccess(response) {
  return {
    type: actionTypes.FETCH_FORM_TEMPLATES_SUCCESS,
    formTemplates: response.form_templates,
    defaultFormTemplate: response.default_form_template,
  };
}

export function setFormTemplatesError(error, requestType) {
  const payloadError = {};

  if (error.name && error.message) {
    payloadError.name = error.name;
    payloadError.message = error.message;
  }

  return {
    type: actionTypes.SET_FORM_TEMPLATES_ERROR,
    payload: {
      error: payloadError,
      requestType: requestType,
    },
  };
}

export function setFormTemplateAllIds(formTemplatesIds) {
  return {
    type: actionTypes.SET_FORM_TEMPLATE_ALL_IDS,
    formTemplatesIds: formTemplatesIds,
  };
}

export function setFetchRequestLoading(isLoading) {
  return {
    type: actionTypes.SET_FORM_TEMPLATE_FETCH_REQUEST_LOADING,
    loading: isLoading,
  };
}

export const createFormTemplate = (createdTemplate) => {
  return {
    type: actionTypes.CREATE_FORM_TEMPLATE,
    value: createdTemplate,
  };
};

export const updateFormTemplate = (createdTemplate) => {
  return {
    type: actionTypes.UPDATE_FORM_TEMPLATE_REQUEST,
    value: createdTemplate,
  };
};

export function fetchFormTemplates() {
  return function (dispatch, getState) {
    const { accountId } = getState().internalReducer.internal;

    // we're about to do an async fetch, set the loading state to true
    dispatch(setFetchRequestLoading(true));

    return formTemplateApi
      .getFormTemplates(accountId)
      .then((formTemplatesResponse) => {
        const formTemplateAllIds = formTemplatesResponse.data.form_templates.map((template) => template.id);

        dispatch(setFormTemplateAllIds(formTemplateAllIds));
        dispatch(fetchFormTemplatesSuccess(formTemplatesResponse.data));
        dispatch(setFetchRequestLoading(false));
      })
      .catch((error) => {
        dispatch(setFetchRequestLoading(false));
        dispatch(setFormTemplatesError(error, 'fetch'));
      });
  };
}

export function saveFormTemplate() {
  return function (dispatch, getState) {
    const { authenticityToken, accountId } = getState().internalReducer.internal;

    const { formTemplateVersion } = getState().formTemplateReducer;

    return formTemplateApi
      .saveFormTemplate(
        {
          authenticity_token: authenticityToken,
          formTemplateData: formTemplateVersion,
        },
        accountId,
      )
      .then((createdFormTemplate) => {
        dispatch(createFormTemplate(createdFormTemplate.data));
      });
  };
}

export function duplicateFormTemplate(formId) {
  return function (dispatch, getState) {
    const { authenticityToken, accountId } = getState().internalReducer.internal;

    return formTemplateApi
      .duplicateFormTemplate(
        {
          authenticity_token: authenticityToken,
        },
        accountId,
        formId,
      )
      .then((response) => {
        dispatch(createFormTemplate(response.data));
      });
  };
}

export function updateFormTemplateTrialContainers(formId, newTrialContainers) {
  return function (dispatch, getState) {
    const { authenticityToken, accountId } = getState().internalReducer.internal;

    return formTemplateApi
      .updateFormTemplateTrialContainers(
        {
          authenticity_token: authenticityToken,
          formTemplateData: {
            trialContainers: newTrialContainers,
          },
        },
        accountId,
        formId,
      )
      .then((response) => {
        dispatch(updateFormTemplate(response.data));
      });
  };
}

export function updateFormTemplateRequest(formId, reasonForChange) {
  return function (dispatch, getState) {
    const { authenticityToken, accountId } = getState().internalReducer.internal;

    const { formTemplateVersion } = getState().formTemplateReducer;

    return formTemplateApi
      .updateFormTemplate(
        {
          authenticity_token: authenticityToken,
          reason_for_change: reasonForChange,
          formTemplateData: formTemplateVersion,
        },
        accountId,
        formId,
      )
      .then((updatedFormTemplate) => {
        dispatch(updateFormTemplate(updatedFormTemplate.data));
      });
  };
}

export function toggleFormTemplateActive(formId, active, reasonForChange) {
  return function (dispatch, getState) {
    const { authenticityToken, accountId } = getState().internalReducer.internal;

    return formTemplateApi
      .toggleFormTemplateActive(
        {
          formTemplateData: {
            active: active,
            reason_for_change: reasonForChange,
          },
          authenticity_token: authenticityToken,
        },
        accountId,
        formId,
      )
      .then((updatedFormTemplate) => {
        dispatch(updateFormTemplate(updatedFormTemplate.data));
      });
  };
}

export function updateFormTemplateWorkflow(formTemplateId, workflowDefinitionId, reasonForChange) {
  return function (dispatch, getState) {
    const { authenticityToken, accountId } = getState().internalReducer.internal;

    return formTemplateApi
      .updateFormTemplateWorkflow(
        {
          authenticity_token: authenticityToken,
          reason_for_change: reasonForChange,
          formTemplateData: {
            workflow_definition_id: workflowDefinitionId,
          },
        },
        accountId,
        formTemplateId,
      )
      .then((response) => {
        dispatch(updateFormTemplate(response.data));
      });
  };
}
